module.exports = {
      id: "linkedin-plain-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-f7c87499d4b6955c7faa356accbb279e.svg#linkedin-plain",
      toString: function () {
        return this.url;
      }
    }